<template lang="pug">
div
  form(
    @submit.prevent="sendEasyLink"
  )
    div(class="title pb-3" color="blue") Where would you like to send this link?
    v-text-field(
      v-model="email"
      :label="emailLabel"
      ref="email"
      @focus="toggleFocus"
      :disabled="emailDisabled"
      id="emailInput"
      :class="customClass('email')"
    )
    div - or -
    v-text-field(
      :label="phoneLabel"
      v-model="phone"
      mask="###-###-####"
      return-masked-value
      hint="305-555-1234"
      ref="phone"
      @focus="toggleFocus"
      :disabled="phoneDisabled"
      id="phoneInput"
      :class="customClass('phone')"
    )
    v-alert(v-model="alertUnsendable"
      color="error"
      icon="warning"
      dismissible
    ) {{ alertMessage }}
    v-btn(type="submit"
      class="full-width mt-4 mx-0 white--text"
      color="blue"
      :disabled="submitDisabled"
    )
      v-icon(class="mr-2") send
      | send
    p.mt-2.caption.font-weight-bold Easy Link will expire if the recipient does not open within 24 hours.
</template>

<script>
  import ValidationRules from '@/mixins/ValidationRules'
  import { mapState } from 'vuex'

  export default {
    mixins: [ValidationRules],
    data() {
      return {
        alertUnsendable: false,
        email: '',
        phone: '',
        focusedField: 'email',
        signature: null
      }
    },
    components: {
      // Signature,
      // LabelValueTile
    },
    computed: {
      ...mapState({
        lender: state => state.loanApplication.lender,
      }),
      phoneDisabled(){
        return this.email ? true : false
      },
      emailDisabled(){
        return this.phone ? true : false
      },
      phoneLabel(){
        return this.email? 'Remove email address in order to use phone number' : 'Phone'
      },
      emailLabel(){
        return this.phone ? 'Remove phone number in order to use email address' : 'Email'
      },
      alertMessage() {
        return !this.email && !this.phone ? 'Missing email and phone. Please include one.'
        : ''
      },

      cleanPhone() {
        return '+1' + this.phone.replace(/-/g, '')
      },

      focusFieldValue() {
        return (this.focusedField === 'email')
          ? this.email
          : (this.focusedField === 'phone')
            ? this.phone
              : null
      },

      isSendable() {
        return this.email || this.phone
      },

      submitDisabled() {
        return this.focusedField === 'email' ? this.emailCheck()(this.email) !== true
        : this.focusedField === 'phone' ? this.phoneNumber()(this.phone) !== true
        : this.signature === 'signature' ? !this.signature !== true
        : true
      },
    },
    watch: {
      focusFieldValue(val) {
        this.$emit('input', val)
      }
    },
    mounted() {
      this.focusField()
    },
    methods: {
      customClass(field) {
        return (this.focusedField !== field) ? 'greyed-out' : ''
      },

      focusField() {
        if (this.focusedField === 'email')
          this.$refs.email.focus()
        else if (this.focusedField === 'phone')
          this.$refs.phone.focus()
      },

      // Need to pass resolve back to stop spinner
      sendEasyLink() {
        const { email, cleanPhone: phone } = this
        const payload = this.focusedField === 'email' ? { email } : { phone }
        payload.signature = this.signature
        if (this.isSendable){
          this.$emit('send', payload)
        } else {
          this.alertUnsendable = true
        }
      },

      toggleFocus(ev) {
        if (ev) {
          if (ev.target.id === 'emailInput')
            this.focusedField = 'email'
          else if (ev.target.id === 'phoneInput')
            this.focusedField = 'phone'
        }
      },

    },
  }
</script>